import { RecordLocator } from '@tff/types';
import { Product } from '@tff/types/tff';
import { BookingSource, BookingResponse, Action } from '@tff/types/tff/retrieve';

export type DeferredPaymentProps = {
  tfmPnr: string;
  product: Product;
  bookingSource: BookingSource;
  origin?: string;
  destination?: string;
  outCabinClasses?: string;
  midocoOrderId?: string;
  midocoOrderNo?: string;
  clientPnr?: RecordLocator;
  channel: string;
  ticketed?: boolean;
  outDeparture?: string;
  outBookingClasses?: string;
  bookingResponse: BookingResponse;
  retryCounter: number;
  bookingSessionId?: string;
  ticketTimeLimit?: string;
  createdAt?: string;
  updatedAt: string;
  version: number;
  recordLocator: RecordLocator;
  action: Action;
  status: 'BOOKED' | 'PENDING' | 'FAILED';
  hidden?: boolean;
};

export enum ProductsEnum {
  ATCOMRES = 'atcomres',
  ATCOMNR = 'atcomnr',
  TFM = 'TFM',
  AIRCRUISER = 'aircruiser',
}

export enum CabinClassEnum {
  Y = 'Y',
  M = 'M',
  W = 'W',
  C = 'C',
  F = 'F',
}

export enum CarrierEnum {
  KL = 'KL',
  EK = 'EK',
  AF = 'AF',
}
